// must be kept in sync with _breakpoints.scss

export const sizes = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const isDesktop = () => !isSize(sizes.md);
export const isTablet = () => isSize(sizes.md);
export const isMobile = () => isSize(sizes.sm);

export const isSize = (size) =>
  window.matchMedia(`(max-width: ${size - 1}px)`).matches;
